<div class="area-dashboard" [class.area-dashboard--mobile]="device.isMobile()">

  <!-- ── Panel : General information ──────────────────────────────────────── -->
  <div class="area-dashboard__panel">
    <app-panel title="General information">

      <!-- Desktop : liste verticale / Mobile : grille 2 colonnes -->
      <div class="info-list" [class.info-list--grid]="device.isMobile()">
        @if (region) {
          <div class="info-item">
            <span class="info-item__label">Area name</span>
            <span class="info-item__value">{{ region.nom }}</span>
          </div>
          <div class="info-item">
            <span class="info-item__label">Sites number</span>
            <span class="info-item__value">{{ sitesCount }}</span>
          </div>
        } @else {
          <span class="info-item__empty">No area selected</span>
        }
      </div>

    </app-panel>
  </div>

  <!-- ── Dashboard Metabase ─────────────────────────────────────────────────── -->
  <div class="area-dashboard__main">
    @if (loadMetabase()) {
      <app-metabase-dashboard
        componentSelector="app-area-dashboard">
      </app-metabase-dashboard>
    } @else {
      <div class="area-dashboard__loading"></div>
    }
  </div>

</div>
